import {
  ChatBox
} from "./chunk-HA6TMEBG.js";
import {
  isCurrency,
  sliderStateAtom,
  titleCase
} from "./chunk-KA7SO5SJ.js";

// src/components/QuoteHelp/QuoteHelp.tsx
import { telephone, message } from "@simplybusiness/icons";
import {
  Flex,
  Icon,
  Link,
  Text as Text2
} from "@simplybusiness/mobius";

// src/components/QuoteHelp/QuoteReference/QuoteReference.tsx
import { Text } from "@simplybusiness/mobius";
import { jsx, jsxs } from "react/jsx-runtime";
var QuoteReference = ({
  referenceNumbers
}) => {
  if (!referenceNumbers || referenceNumbers.length === 0) return null;
  function getJoinedReferences(referenceNumbers2) {
    if (!referenceNumbers2.length) return null;
    const items = referenceNumbers2.map((ref) => /* @__PURE__ */ jsx("strong", { className: "mobius-quote-help__reference-number", children: ref }, ref));
    if (items.length === 1) {
      return items[0];
    }
    if (items.length === 2) {
      return [items[0], " and ", items[1]];
    }
    return [
      ...items.slice(0, -1).map((item) => [item, ", "]),
      "and ",
      items[items.length - 1]
    ].flat();
  }
  return /* @__PURE__ */ jsxs(Text, { variant: "body", children: [
    "Quote reference ID: ",
    getJoinedReferences(referenceNumbers)
  ] });
};

// src/components/QuoteHelp/QuoteHelp.tsx
import { forwardRef } from "react";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var QuoteHelp = forwardRef((props, ref) => {
  const { contactPhoneNumber, referenceNumbers, chatWithAgent, ...otherProps } = props;
  return /* @__PURE__ */ jsxs2(ChatBox, { ref, ...otherProps, children: [
    /* @__PURE__ */ jsx2(Text2, { variant: "body", children: "Have a question about your quote? Give us a call \u2014 we\u2019re here to help." }),
    (contactPhoneNumber || chatWithAgent) && /* @__PURE__ */ jsxs2(Flex, { className: "mobius-quote-help__contact-container", children: [
      contactPhoneNumber && /* @__PURE__ */ jsxs2(
        Link,
        {
          href: `tel:${contactPhoneNumber}`,
          className: "mobius-quote-help__contact-phone-number",
          children: [
            /* @__PURE__ */ jsx2(Icon, { fixedWidth: true, icon: telephone }),
            " ",
            contactPhoneNumber
          ]
        }
      ),
      chatWithAgent && /* @__PURE__ */ jsx2(ChatBox.ChatLink, { icon: message })
    ] }),
    /* @__PURE__ */ jsx2(QuoteReference, { referenceNumbers })
  ] });
});
QuoteHelp.displayName = "QuoteHelp";

// src/components/QuoteCards/QuoteCard/Coverage/transformCoverage.ts
var formatAmount = (amount) => {
  if (!amount) return amount;
  return amount.replace(",000,000", "M").replace(/,(\d+)00,000/, (_, digits) => `.${digits}M`).replace(/,(\d+)0,000/, (_, digits) => `.${digits}M`).replace(",000", "K").replace(/([£$]\d+)k/g, "$1K").replace(/([£$]\d+)m/g, "$1M");
};
var findHelpText = (helpTextArray, coverage) => {
  const helpTextObject = helpTextArray.find(
    (item) => item.coverage.toLowerCase() === coverage.toLowerCase()
  );
  return helpTextObject && helpTextObject.text;
};
var formatCoverLimit = (cover, helpText = []) => {
  const [title, amount] = cover.split(": ");
  const explainer = findHelpText(helpText, title);
  let displayTitle = titleCase(title);
  if (displayTitle === "Claims Made Limit") {
    displayTitle = "Claim Limit";
  }
  return {
    title: displayTitle,
    amount: formatAmount(amount),
    explainer
  };
};
var extractCoverAmount = (cover) => {
  const [, amount] = cover.split(": ");
  return amount;
};
var formatExcesses = (displayExcess, specificExcesses = [], helpText = []) => {
  const allExcesses = [
    ...specificExcesses,
    { excessName: "Deductibles", excessValue: displayExcess }
  ];
  return allExcesses.map(({ excessName, excessValue }) => {
    return {
      title: titleCase(excessName),
      amount: formatAmount(excessValue),
      explainer: findHelpText(helpText, excessName)
    };
  });
};
var transformCoverage = (covers) => {
  return covers.filter(
    (c) => c.quoteDetailsDisplayLimits.length > 0 || c.coverName?.match(/^Other States Coverage?$/i)
  );
};
var transformExtraCoverage = (covers) => {
  return covers.filter((c) => c.extraCover);
};
var isAdditionalInsured = (cover) => {
  return cover.coverName.match(/^Additional insureds?$/i);
};
var isLimitIncluded = (limit) => {
  const lowerLimit = limit.toLowerCase();
  return lowerLimit.includes("occurrence limit") || lowerLimit.includes("aggregate limit");
};
var getCoverLimits = (product, limits, filterQcpLimits, displayVariant, helpText, withModal) => {
  const filteredLimits = filterQcpLimits && displayVariant === "qcp" ? limits.filter(isLimitIncluded) : limits;
  return filteredLimits.map((limit) => {
    const { title, amount, explainer } = formatCoverLimit(limit, helpText);
    return {
      product,
      title,
      amount,
      explainer,
      withModal
    };
  });
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/Coverage.tsx
import {
  Accordion,
  Box,
  Modal as Modal2,
  Text as Text4,
  useBreakpoint as useBreakpoint3
} from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext3 } from "@simplybusiness/services";
import classNames2 from "classnames/dedupe";
import { useCallback as useCallback2, useState as useState2 } from "react";

// src/constants/breakpoints.ts
var customBreakpoints = [
  { size: "xs", value: 320 },
  { size: "sm", value: 480 },
  { size: "md", value: 600 },
  { size: "lg", value: 850 },
  { size: "xl", value: 1024 }
];

// src/components/QuoteCards/QuoteCard/CoverLimit/CoverLimit.tsx
import { Flex as Flex4 } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { useAtom } from "jotai";
import { useCallback } from "react";

// src/components/QuoteCards/QuoteCard/InfoModal/index.tsx
import { useBreakpoint } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/InfoModal/CardModal.tsx
import { circleQuestion } from "@simplybusiness/icons";
import { Button, Flex as Flex2, Icon as Icon2, Modal } from "@simplybusiness/mobius";
import { useState } from "react";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var CardModal = ({
  toggleText,
  title,
  body,
  onOpen,
  toggleIcon = true
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    if (onOpen) {
      onOpen();
    }
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  return /* @__PURE__ */ jsxs3(Flex2, { gap: "xxs", children: [
    /* @__PURE__ */ jsx3(
      Button,
      {
        variant: "ghost",
        className: "mobius-quote-card__modal-trigger",
        onClick: handleOpen,
        children: /* @__PURE__ */ jsxs3(Flex2, { children: [
          /* @__PURE__ */ jsx3("span", { className: "mobius-quote-card__explainer-title", children: toggleText }),
          toggleIcon && /* @__PURE__ */ jsx3(
            Icon2,
            {
              icon: circleQuestion,
              size: "sm",
              className: "mobius-quote-card__explainer-icon"
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsxs3(
      Modal,
      {
        isOpen: open,
        onClose: handleClose,
        className: "mobius-quote-card__modal-container",
        animation: "fade",
        children: [
          /* @__PURE__ */ jsx3(Modal.Header, { children: title }),
          /* @__PURE__ */ jsx3(Modal.Content, { children: body })
        ]
      }
    )
  ] });
};

// src/components/QuoteCards/QuoteCard/InfoModal/CardPopover.tsx
import { circleQuestion as circleQuestion2 } from "@simplybusiness/icons";
import { Button as Button2, Flex as Flex3, Icon as Icon3, Popover } from "@simplybusiness/mobius";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var CardPopover = ({
  toggleText,
  body,
  onOpen,
  toggleIcon = true,
  isCoreCover = false
}) => /* @__PURE__ */ jsx4(Flex3, { gap: "xxs", children: /* @__PURE__ */ jsx4(
  Popover,
  {
    className: "mobius-quote-card__info-popover",
    trigger: /* @__PURE__ */ jsx4(Button2, { variant: "ghost", className: "mobius-quote-card__modal-trigger", children: /* @__PURE__ */ jsxs4(Flex3, { children: [
      /* @__PURE__ */ jsx4(
        "span",
        {
          className: isCoreCover ? "" : "mobius-quote-card__explainer-title",
          children: toggleText
        }
      ),
      " ",
      toggleIcon && /* @__PURE__ */ jsx4(
        Icon3,
        {
          icon: circleQuestion2,
          size: "sm",
          className: "mobius-quote-card__explainer-icon"
        }
      )
    ] }) }),
    onOpen,
    children: body
  }
) });

// src/components/QuoteCards/QuoteCard/InfoModal/index.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var InfoModal = ({ title, ...props }) => {
  const { up } = useBreakpoint(customBreakpoints);
  if (up("md")) {
    return /* @__PURE__ */ jsx5(CardPopover, { ...props });
  }
  return /* @__PURE__ */ jsx5(CardModal, { title, ...props });
};

// src/components/QuoteCards/QuoteCard/CoverLimit/CoverLimit.tsx
import { Fragment, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var CoverLimit = ({
  product,
  title,
  amount,
  explainer,
  withModal,
  isCoreCover
}) => {
  const { snowplow } = useSnowplowContext();
  const [sliderIsOpen] = useAtom(sliderStateAtom);
  const handleOpen = useCallback(() => {
    const category = `${sliderIsOpen ? "quote_details_slider" : "qcp"}_coverage_selection`;
    snowplow?.trigger("coverageModalOpened", { category, product, title });
  }, [sliderIsOpen, snowplow, product, title]);
  const modalTitle = /* @__PURE__ */ jsxs5(Fragment, { children: [
    title,
    /* @__PURE__ */ jsx6("br", {}),
    amount
  ] });
  return /* @__PURE__ */ jsxs5(
    Flex4,
    {
      justifyContent: "space-between",
      gap: "xs",
      className: isCoreCover ? "" : "mobius-quote-card__cover",
      flexGrow: 1,
      children: [
        explainer && withModal ? /* @__PURE__ */ jsx6(
          InfoModal,
          {
            toggleText: title,
            title: modalTitle,
            body: explainer,
            onOpen: handleOpen,
            isCoreCover
          }
        ) : title,
        /* @__PURE__ */ jsx6("strong", { className: isCoreCover ? "" : "mobius-quote-card__cover-amount", children: amount })
      ]
    }
  );
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/CoverageItems.tsx
import classNames from "classnames/dedupe";
import { tick, cross } from "@simplybusiness/icons";
import { Flex as Flex5, Icon as Icon4, Text as Text3 } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/ViewExcess.tsx
import { Link as Link2, useBreakpoint as useBreakpoint2 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext2 } from "@simplybusiness/services";

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/formatExcesses.ts
var formatExcesses2 = (displayExcess, specificExcesses = [], helpText = []) => {
  const otherClaimsWording = specificExcesses.length ? "All other Claims" : "All Claims";
  const otherClaimsValue = displayExcess + (isCurrency(displayExcess) ? " excess" : "");
  const allExcesses = [
    ...specificExcesses,
    { excessName: otherClaimsWording, excessValue: otherClaimsValue }
  ];
  return allExcesses.map(({ excessName, excessValue }) => {
    return {
      title: titleCase(excessName),
      amount: formatAmount(excessValue),
      explainer: findHelpText(helpText, excessName)
    };
  });
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/ViewExcess.tsx
import { Fragment as Fragment2, jsx as jsx7 } from "react/jsx-runtime";
var ViewExcess = ({
  displayName,
  displayExcess,
  quoteCardExcesses,
  onOpen
}) => {
  const { snowplow } = useSnowplowContext2();
  const excesses = formatExcesses2(
    displayExcess,
    quoteCardExcesses
  );
  const { down } = useBreakpoint2();
  const isMobileDevice = down("md");
  const handleLinkClick = ({ displayName: displayName2 }) => {
    snowplow?.trigger("deductiblesClickedUk", {
      label: displayName2,
      deviceType: isMobileDevice ? "mobile" : "desktop"
    });
    onOpen({
      displayName: displayName2,
      excesses
    });
  };
  return /* @__PURE__ */ jsx7(Fragment2, { children: excesses.length > 0 && /* @__PURE__ */ jsx7(
    Link2,
    {
      className: "mobius-quote-card__coverage-item-excess-link",
      onClick: () => handleLinkClick({ displayName }),
      children: "View excess"
    }
  ) });
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/ExcessWording.tsx
import { Fragment as Fragment3, jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var ExcessWording = ({
  displayLimit,
  indemnityPeriod
}) => {
  const formattedDisplayLimit = displayLimit ? formatAmount(displayLimit) : "";
  return /* @__PURE__ */ jsxs6(Fragment3, { children: [
    /* @__PURE__ */ jsx8("strong", { children: formattedDisplayLimit }),
    indemnityPeriod && /* @__PURE__ */ jsxs6(Fragment3, { children: [
      /* @__PURE__ */ jsx8("br", {}),
      /* @__PURE__ */ jsx8("strong", { children: indemnityPeriod })
    ] })
  ] });
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/CoverageItems.tsx
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var CoverageItems = ({ covers, onOpen }) => {
  return /* @__PURE__ */ jsx9(
    Flex5,
    {
      flexDirection: "column",
      gap: "xs",
      className: "mobius-quote-card__coverage-items",
      children: covers.map(
        ({
          displayName,
          coverName,
          covered,
          displayLimit,
          indemnityPeriod,
          displayExcess,
          quoteCardExcesses
        }) => {
          const iconClassName = classNames({
            "mobius-quote-card__coverage-tick-icon": covered,
            "mobius-quote-card__coverage-cross-icon": !covered
          });
          return /* @__PURE__ */ jsxs7("div", { className: "mobius-quote-card__coverage-item", children: [
            /* @__PURE__ */ jsx9("div", { children: /* @__PURE__ */ jsxs7(Flex5, { children: [
              /* @__PURE__ */ jsx9(
                Icon4,
                {
                  icon: covered ? tick : cross,
                  className: iconClassName,
                  "data-testid": "coverage-item-icon",
                  title: covered ? "This coverage is included" : "This coverage is not included"
                }
              ),
              /* @__PURE__ */ jsx9(Text3, { className: "mobius-quote-card__coverage-header-title", children: displayName })
            ] }) }),
            /* @__PURE__ */ jsx9("div", { children: covered ? /* @__PURE__ */ jsx9(
              ViewExcess,
              {
                displayName,
                displayExcess,
                quoteCardExcesses,
                onOpen
              }
            ) : "Not included" }),
            /* @__PURE__ */ jsx9("div", { className: "mobius-quote-card__coverage-item-excess-wording", children: covered ? /* @__PURE__ */ jsx9(
              ExcessWording,
              {
                displayLimit,
                indemnityPeriod
              }
            ) : /* @__PURE__ */ jsx9("div", { children: "-" }) })
          ] }, coverName);
        }
      )
    }
  );
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/Coverage.tsx
import { Fragment as Fragment4, jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var Coverage = ({ covers, className }) => {
  const [open, setOpen] = useState2(false);
  const [modalData, setModalData] = useState2({
    displayName: "",
    excesses: []
  });
  const { down } = useBreakpoint3(customBreakpoints);
  const isMobileDevice = down("md");
  const { snowplow } = useSnowplowContext3();
  const classes = classNames2("mobius-quote-card__coverage", className);
  const handleOpen = useCallback2(
    ({ displayName, excesses }) => {
      setModalData({ displayName, excesses });
      setOpen(true);
    },
    []
  );
  const handleOpenAccordion = useCallback2(() => {
    snowplow?.trigger("coverageInfoClicked", {
      deviceType: isMobileDevice ? "mobile" : "desktop"
    });
  }, [isMobileDevice, snowplow]);
  return /* @__PURE__ */ jsx10(Fragment4, { children: /* @__PURE__ */ jsxs8(Box, { className: classes, "data-testid": "quote-coverage-uk", children: [
    isMobileDevice ? /* @__PURE__ */ jsx10(
      Accordion,
      {
        showText: "Show coverage info",
        hideText: "Hide coverage info",
        onOpen: handleOpenAccordion,
        children: /* @__PURE__ */ jsx10(CoverageItems, { covers, onOpen: handleOpen })
      }
    ) : /* @__PURE__ */ jsxs8(Fragment4, { children: [
      /* @__PURE__ */ jsx10(Text4, { className: "mobius-quote-card__coverage-title", variant: "h3", children: "Coverage Information" }),
      /* @__PURE__ */ jsx10(CoverageItems, { covers, onOpen: handleOpen })
    ] }),
    /* @__PURE__ */ jsxs8(
      Modal2,
      {
        className: "mobius-quote-card__coverage-item-excess-modal",
        isOpen: open,
        onClose: () => setOpen(false),
        children: [
          /* @__PURE__ */ jsxs8(Modal2.Header, { children: [
            modalData.displayName,
            " excess"
          ] }),
          /* @__PURE__ */ jsx10(Modal2.Content, { children: modalData.excesses.map((cover) => /* @__PURE__ */ jsx10(
            CoverLimit,
            {
              ...cover,
              product: modalData.displayName
            },
            cover.title
          )) })
        ]
      }
    )
  ] }) });
};

// src/components/QuoteCards/QuoteCard/Coverage/Coverage.tsx
import { fileCertificate } from "@simplybusiness/icons";
import { Box as Box4, Flex as Flex12, Icon as Icon11, Text as Text12 } from "@simplybusiness/mobius";
import classNames3 from "classnames/dedupe";

// src/components/QuoteCards/QuoteCard/Coverage/IncludedByInsurerCoverage/IncludedByInsurerCoverage.tsx
import { tick as tick2 } from "@simplybusiness/icons";
import { Flex as Flex6, Icon as Icon5 } from "@simplybusiness/mobius";
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var IncludedByInsurerCoverage = ({
  coverageTitle,
  helpText
}) => {
  return /* @__PURE__ */ jsx11(Flex6, { flexDirection: "column", children: /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsxs9(
    Flex6,
    {
      flexGrow: 1,
      alignItems: "center",
      className: "mobius-quote-card__included-by-insurer",
      children: [
        /* @__PURE__ */ jsx11(
          Icon5,
          {
            className: "mobius-quote-card__included-by-insurer-icon",
            icon: tick2
          }
        ),
        /* @__PURE__ */ jsx11(
          CoverLimit,
          {
            title: coverageTitle,
            amount: "Included",
            explainer: helpText && findHelpText(helpText, coverageTitle)
          }
        )
      ]
    }
  ) }, coverageTitle) });
};

// src/components/QuoteCards/QuoteCard/Upsells/Upsells.tsx
import { Box as Box3, Accordion as Accordion2 } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/FileCirclePlus/FileCirclePlus.tsx
import { fileCirclePlus } from "@simplybusiness/icons";
import { Flex as Flex7, Icon as Icon6, Text as Text5 } from "@simplybusiness/mobius";
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var FileCirclePlus = ({ text }) => /* @__PURE__ */ jsxs10(Flex7, { className: "mobius-quote-card__file-circle-plus", gap: "xs", children: [
  /* @__PURE__ */ jsx12(
    Icon6,
    {
      icon: fileCirclePlus,
      size: "sm",
      color: "var(--color-text)",
      title: "Additional coverage available"
    }
  ),
  /* @__PURE__ */ jsx12(Text5, { variant: "small", children: text })
] });

// src/components/QuoteCards/QuoteCard/Upsells/UpsellItem.tsx
import { Box as Box2, Text as Text6 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext4 } from "@simplybusiness/services";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var UpsellItem = ({ item, displayVariant }) => {
  const { snowplow } = useSnowplowContext4();
  const onTooltipOpen = (upsellName) => {
    snowplow?.trigger(`${displayVariant}UpsellTooltipHelperClicked`, {
      label: upsellName
    });
  };
  return /* @__PURE__ */ jsxs11(Box2, { className: "mobius-quote-card__upsell-item", children: [
    /* @__PURE__ */ jsx13(
      InfoModal,
      {
        toggleText: item.primaryText,
        title: item.primaryText,
        body: item.secondaryText,
        onOpen: () => onTooltipOpen(item.primaryText)
      }
    ),
    /* @__PURE__ */ jsx13(Text6, { className: "mobius-quote-card__upsell-price", children: item.formattedPrice })
  ] });
};

// src/components/QuoteCards/QuoteCard/Upsells/Upsells.tsx
import { useSnowplowContext as useSnowplowContext5 } from "@simplybusiness/services";
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var Upsells = ({ upsells, displayVariant }) => {
  const [firstUpsell, ...remainingUpsells] = upsells;
  const { snowplow } = useSnowplowContext5();
  const onAccordionOpen = () => {
    const remainingUpsellsList = remainingUpsells.map((item) => item.primaryText).join(", ");
    snowplow?.trigger(`${displayVariant}UpsellAccordionClicked`, {
      label: remainingUpsellsList
    });
  };
  return /* @__PURE__ */ jsxs12(Box3, { className: "mobius-quote-card__upsells", children: [
    /* @__PURE__ */ jsx14(FileCirclePlus, { text: "ADD-ONS AVAILABLE IN THE NEXT STEPS" }),
    /* @__PURE__ */ jsx14("div", { className: "mobius-quote-card__upsells-first-upsell", children: /* @__PURE__ */ jsx14(
      UpsellItem,
      {
        item: firstUpsell,
        displayVariant
      },
      firstUpsell.primaryText
    ) }),
    remainingUpsells.length > 0 && /* @__PURE__ */ jsx14(
      Accordion2,
      {
        showText: "View more available add-ons",
        hideText: "Show less add-ons",
        onOpen: onAccordionOpen,
        headerPosition: "bottom",
        children: remainingUpsells.map((item) => /* @__PURE__ */ jsx14(
          UpsellItem,
          {
            item,
            displayVariant
          },
          item.primaryText
        ))
      }
    )
  ] });
};

// src/components/QuoteCards/QuoteCard/Tag/Tag.tsx
import { tag } from "@simplybusiness/icons";
import { Flex as Flex8, Icon as Icon7, Text as Text7 } from "@simplybusiness/mobius";
import { jsx as jsx15, jsxs as jsxs13 } from "react/jsx-runtime";
var Tag = ({ text }) => /* @__PURE__ */ jsxs13(Flex8, { alignItems: "flex-start", className: "mobius-quote-card__tag", gap: "xxs", children: [
  /* @__PURE__ */ jsx15(Icon7, { icon: tag, size: "sm", title: "Quote tag" }),
  /* @__PURE__ */ jsx15(Text7, { variant: "small", children: text })
] });

// src/components/QuoteCards/QuoteCard/Upsells/UpsellContent.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var UpsellContent = ({
  upsells,
  additionalCoverage = false,
  displayVariant
}) => {
  if (upsells.length > 0) {
    return /* @__PURE__ */ jsx16(Upsells, { upsells, displayVariant });
  }
  if (additionalCoverage) {
    return /* @__PURE__ */ jsx16(Tag, { text: "Extra coverage available in the next steps" });
  }
};

// src/components/QuoteCards/QuoteCard/Coverage/DisplayCover/DisplayCover.tsx
import { tick as tick4 } from "@simplybusiness/icons";
import { Flex as Flex11, Icon as Icon10, Text as Text11 } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/PriceDetails/PriceDetails.tsx
import { telephone as telephone2 } from "@simplybusiness/icons";
import { Icon as Icon8, Link as Link3, Text as Text8 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext6 } from "@simplybusiness/services";
import { Fragment as Fragment5, jsx as jsx17, jsxs as jsxs14 } from "react/jsx-runtime";
var PriceDetails = ({ priceDetails }) => {
  const { snowplow } = useSnowplowContext6();
  const { displayText, phoneNumber } = priceDetails;
  const modalText = /* @__PURE__ */ jsxs14(Fragment5, { children: [
    displayText.map((line) => /* @__PURE__ */ jsx17(Text8, { children: line }, line)),
    /* @__PURE__ */ jsx17(Text8, { children: /* @__PURE__ */ jsx17("strong", { children: phoneNumber.displayText }) }),
    /* @__PURE__ */ jsx17(Text8, { children: /* @__PURE__ */ jsxs14(
      Link3,
      {
        className: "mobius-quote-card__price-details-phone",
        href: `tel:${phoneNumber.number}`,
        children: [
          /* @__PURE__ */ jsx17(
            Icon8,
            {
              icon: telephone2,
              className: "mobius-quote-card__price-details-icon"
            }
          ),
          phoneNumber.formatted
        ]
      }
    ) })
  ] });
  return /* @__PURE__ */ jsx17("div", { className: "mobius-quote-card__price-details", children: /* @__PURE__ */ jsx17(
    CardModal,
    {
      onOpen: () => snowplow?.trigger("priceDetailsPopUpOpened"),
      toggleText: "Price Details",
      title: "Price Details",
      body: modalText,
      toggleIcon: false
    }
  ) });
};

// src/components/QuoteCards/QuoteCard/Coverage/ExtraCoverage/ExtraCoverage.tsx
import { circleInfo, tick as tick3 } from "@simplybusiness/icons";
import { Flex as Flex9, Icon as Icon9, Text as Text9 } from "@simplybusiness/mobius";
import { jsx as jsx18, jsxs as jsxs15 } from "react/jsx-runtime";
var ExtraCoverage = ({
  extraCovers,
  parentCover,
  variant,
  helpText
}) => {
  return extraCovers && /* @__PURE__ */ jsx18(Flex9, { flexDirection: "column", children: extraCovers.filter((cover) => cover.parentCover == parentCover).map((cover) => /* @__PURE__ */ jsxs15("div", { children: [
    /* @__PURE__ */ jsxs15(
      Flex9,
      {
        flexGrow: 1,
        alignItems: "center",
        className: "mobius-quote-card__extra-coverage-item",
        children: [
          /* @__PURE__ */ jsx18(
            Icon9,
            {
              className: "mobius-quote-card__coverage-tick-icon",
              icon: tick3
            }
          ),
          /* @__PURE__ */ jsx18(
            CoverLimit,
            {
              title: isAdditionalInsured(cover) ? "Additional Insured" : cover.displayName,
              amount: isAdditionalInsured(cover) ? "Included" : formatAmount(cover.displayLimit),
              explainer: helpText && findHelpText(helpText, cover.displayName),
              withModal: true
            }
          )
        ]
      }
    ),
    variant == "qds" && isAdditionalInsured(cover) && /* @__PURE__ */ jsx18(AdditionalInsureds, {})
  ] }, cover.coverName)) });
};
var AdditionalInsureds = () => /* @__PURE__ */ jsxs15(
  Flex9,
  {
    alignItems: "center",
    gap: "sm",
    flexGrow: 1,
    className: "mobius-quote-card__additional-insureds",
    children: [
      /* @__PURE__ */ jsx18("div", { role: "img", "aria-label": "information icon", children: /* @__PURE__ */ jsx18(
        Icon9,
        {
          icon: circleInfo,
          color: "var(--color-neutral-700)",
          size: "md",
          fixedWidth: true
        }
      ) }),
      /* @__PURE__ */ jsx18(Text9, { spacing: "loose", variant: "small", children: "Additional insured details can be added after purchase" })
    ]
  }
);

// src/components/QuoteCards/QuoteCard/Coverage/Deductibles/Deductibles.tsx
import { Accordion as Accordion3, Flex as Flex10, Text as Text10 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext7 } from "@simplybusiness/services";
import { jsx as jsx19, jsxs as jsxs16 } from "react/jsx-runtime";
var Deductibles = ({
  excesses,
  excessTitle,
  coverName,
  variant
}) => {
  const { snowplow } = useSnowplowContext7();
  const hasExcesses = excesses.length > 0;
  if (excessTitle === "Deductible") {
    excessTitle += "s";
  }
  if (variant === "qcp") {
    return hasExcesses && /* @__PURE__ */ jsx19(
      Accordion3,
      {
        showText: excessTitle,
        hideText: excessTitle,
        onOpen: () => snowplow?.trigger("deductiblesClicked"),
        headerPosition: "top",
        children: excesses.map((cover) => /* @__PURE__ */ jsx19(CoverLimit, { ...cover, product: coverName }, cover.title))
      }
    );
  }
  return hasExcesses && /* @__PURE__ */ jsxs16(Flex10, { className: "mobius-quote-card__deductibles", flexDirection: "column", children: [
    /* @__PURE__ */ jsx19(Text10, { className: "mobius-quote-card__deductibles-title", children: excessTitle }),
    excesses.map((cover) => /* @__PURE__ */ jsx19(CoverLimit, { ...cover, product: coverName }, cover.title))
  ] });
};

// src/components/QuoteCards/QuoteCard/CoverLimits.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var CoverLimits = ({ coverLimits }) => {
  return coverLimits.map((coverLimit) => /* @__PURE__ */ jsx20(CoverLimit, { ...coverLimit }, coverLimit.title));
};

// src/components/QuoteCards/QuoteCard/Coverage/DisplayCover/DisplayCover.tsx
import { jsx as jsx21, jsxs as jsxs17 } from "react/jsx-runtime";
var CoverHeader = ({ coverage, display, helpText }) => /* @__PURE__ */ jsxs17(Flex11, { children: [
  /* @__PURE__ */ jsx21(Icon10, { icon: tick4, className: "mobius-quote-card__coverage-tick-icon" }),
  /* @__PURE__ */ jsx21(Text11, { className: "mobius-quote-card__coverage-header-title", children: display.oneLineDisplay ? /* @__PURE__ */ jsx21(
    CoverLimit,
    {
      title: coverage.displayName,
      amount: extractCoverAmount(coverage.limits[0]),
      explainer: findHelpText(helpText, coverage.displayName),
      withModal: true,
      isCoreCover: true
    }
  ) : coverage.displayName })
] });
var showOnQcp = (variant, oneLine = false, qds = false) => !qds && (oneLine || variant === "qcp");
var showDeductibles = (name, variant) => !(name === "Workers Compensation" && variant === "qcp");
var DisplayCover = ({
  coverage,
  display,
  excess,
  displayVariant,
  helpText,
  priceDetails,
  extraCovers
}) => {
  const shouldShowHeader = showOnQcp(displayVariant, display.oneLineDisplay, display.qdsDisplay) || displayVariant === "qds";
  const shouldShowDeductibles = shouldShowHeader && showDeductibles(coverage.displayName, displayVariant);
  const shouldShowExtraCovers = extraCovers && extraCovers.length > 1;
  const shouldShowPriceDetails = displayVariant === "qcp" && priceDetails;
  return /* @__PURE__ */ jsx21(
    Flex11,
    {
      flexGrow: 1,
      alignItems: "flex-start",
      className: "mobius-quote-card__coverage-item",
      children: /* @__PURE__ */ jsxs17(Flex11, { flexDirection: "column", flexGrow: 1, children: [
        shouldShowHeader && /* @__PURE__ */ jsx21(
          CoverHeader,
          {
            coverage,
            display,
            helpText
          }
        ),
        !display.oneLineDisplay && /* @__PURE__ */ jsx21(
          CoverLimits,
          {
            coverLimits: getCoverLimits(
              coverage.coverName,
              coverage.limits,
              display.filterQcpLimits || false,
              displayVariant,
              helpText,
              display.withModal
            )
          }
        ),
        shouldShowPriceDetails && /* @__PURE__ */ jsx21(PriceDetails, { priceDetails }),
        shouldShowExtraCovers && /* @__PURE__ */ jsx21(
          ExtraCoverage,
          {
            extraCovers,
            parentCover: coverage.coverName,
            variant: displayVariant,
            helpText
          }
        ),
        shouldShowDeductibles && /* @__PURE__ */ jsx21(
          Deductibles,
          {
            excesses: formatExcesses(
              coverage.displayExcess,
              displayVariant === "qcp" ? excess.quoteCardExcesses : excess.quoteSliderExcesses,
              helpText
            ),
            excessTitle: coverage.excessTitle,
            coverName: coverage.coverName,
            variant: displayVariant
          }
        )
      ] })
    },
    coverage.coverName
  );
};

// src/components/QuoteCards/QuoteCard/Coverage/Coverage.tsx
import { jsx as jsx22, jsxs as jsxs18 } from "react/jsx-runtime";
var Coverage2 = ({
  helpText = [],
  covers,
  extraCovers,
  className,
  displayVariant,
  withModal,
  additionalCoverage,
  upsells = []
}) => {
  const transformedCovers = transformCoverage(covers);
  const hasOtherStatesCoverage = displayVariant !== "qcp" && transformedCovers.some(
    (cover) => cover.displayName === "Other States Coverage"
  );
  const hasAccidentPolicyCoverage = covers.some(
    (cover) => cover.displayName === "24/7 Medical Expense"
  );
  const displayCovers = transformedCovers.filter(
    (cover) => cover.displayName !== "Other States Coverage"
  );
  const coverageTitle = "Coverage Information";
  const coverageContainerStyles = classNames3(
    "mobius-quote-card__coverage",
    className
  );
  return /* @__PURE__ */ jsxs18(Box4, { className: coverageContainerStyles, children: [
    /* @__PURE__ */ jsxs18(Text12, { className: "mobius-quote-card__coverage-title", variant: "h3", children: [
      /* @__PURE__ */ jsx22(
        Icon11,
        {
          "data-testid": "coverage-title-icon",
          icon: fileCertificate,
          title: "Coverage information document"
        }
      ),
      "\xA0",
      coverageTitle
    ] }),
    /* @__PURE__ */ jsxs18(
      Flex12,
      {
        flexDirection: "column",
        gap: "sm",
        className: "mobius-quote-card__coverage-items",
        children: [
          displayCovers.map(
            ({
              displayName,
              coverName,
              quoteDetailsDisplayLimits: limits,
              quoteCardExcesses,
              quoteSliderExcesses,
              excessTitle,
              displayExcess,
              priceDetails,
              oneLineDisplay,
              qdsDisplay,
              filterQcpLimits
            }) => /* @__PURE__ */ jsx22(
              DisplayCover,
              {
                coverage: {
                  displayName,
                  coverName,
                  limits,
                  excessTitle,
                  displayExcess
                },
                display: {
                  oneLineDisplay,
                  qdsDisplay,
                  filterQcpLimits,
                  withModal
                },
                excess: {
                  quoteCardExcesses,
                  quoteSliderExcesses
                },
                displayVariant,
                helpText,
                priceDetails,
                extraCovers
              },
              coverName
            )
          ),
          hasOtherStatesCoverage && /* @__PURE__ */ jsx22(
            IncludedByInsurerCoverage,
            {
              coverageTitle: "Other States Coverage",
              helpText
            }
          ),
          hasAccidentPolicyCoverage && /* @__PURE__ */ jsx22(
            IncludedByInsurerCoverage,
            {
              coverageTitle: "24/7 Medical Expense",
              helpText
            }
          ),
          /* @__PURE__ */ jsx22(
            UpsellContent,
            {
              upsells,
              additionalCoverage,
              displayVariant
            }
          )
        ]
      }
    )
  ] });
};

// src/components/QuoteCards/variants.tsx
var UK_VARIANTS = [
  "referral-reasons",
  "without-qdp-drawer",
  "unsupported-trade-referral"
];
var variants = (variant) => {
  return UK_VARIANTS.includes(variant);
};

// src/components/QuoteCards/QuoteCard/Coverage/index.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var Coverage3 = (props) => {
  const { variant } = props;
  const isUKVariant = variants(variant);
  if (isUKVariant) {
    return /* @__PURE__ */ jsx23(Coverage, { ...props });
  }
  return /* @__PURE__ */ jsx23(Coverage2, { ...props });
};

// src/components/QuoteCards/QuoteCard/Logo/Logo.tsx
import classNames4 from "classnames";
import { jsx as jsx24 } from "react/jsx-runtime";
var Logo = ({ logoPath, className, alt }) => {
  const origin = "http://localhost:3000";
  const logoUrl = logoPath?.startsWith("http") ? logoPath : `${origin}${logoPath}`;
  const classes = classNames4("mobius-quote-details__logo", className);
  const altText = alt ?? "Provider logo";
  if (!logoPath) {
    return null;
  }
  return /* @__PURE__ */ jsx24("img", { src: logoUrl, alt: altText, className: classes });
};

// src/components/shared/ProductInfo/ProductInfo.tsx
import { Flex as Flex13, Text as Text13 } from "@simplybusiness/mobius";
import { jsx as jsx25, jsxs as jsxs19 } from "react/jsx-runtime";
var ProductInfo = (props) => {
  const { logo, productTitle, premium, policyStartDate, children } = props;
  return /* @__PURE__ */ jsx25(Flex13, { flexDirection: "column", children: /* @__PURE__ */ jsxs19("div", { className: "mobius-payment-info__multi-product", children: [
    /* @__PURE__ */ jsx25(Logo, { logoPath: logo, className: "mobius-payment-info__logo" }),
    /* @__PURE__ */ jsxs19(
      Flex13,
      {
        alignItems: "baseline",
        gap: "xs",
        justifyContent: "space-between",
        className: "mobius-payment-info__multi-product-text",
        flexGrow: 1,
        children: [
          /* @__PURE__ */ jsx25("strong", { children: productTitle }),
          /* @__PURE__ */ jsx25("strong", { children: premium })
        ]
      }
    ),
    /* @__PURE__ */ jsxs19(Text13, { className: "mobius-payment-info__start-date", children: [
      "Policy starting ",
      policyStartDate
    ] }),
    children
  ] }) });
};

export {
  Logo,
  ProductInfo,
  customBreakpoints,
  InfoModal,
  CoverLimit,
  formatAmount,
  transformCoverage,
  transformExtraCoverage,
  CoverageItems,
  variants,
  Coverage3 as Coverage,
  QuoteHelp
};
